import React, { useContext } from "react";
import { Provider } from "react-redux";
import { MasterNode } from "../../audio/MasterNode";
import { Editor } from "../../components/Editor";
import { Drawer } from "antd";
import { Container } from "./styles";
import { EditorContext } from "../../context/EditorContext/EditorProvider";
import { OfflineAudioComponent } from "../../audio/OfflineAudioComponent";

const EditorDrawer = ({ mask = true, maskClosable = true }) => {
  const editor = useContext(EditorContext);

  return (
    <Container>
      <Drawer
        placement="bottom"
        getContainer={false}
        mask={mask}
        maskClosable={maskClosable}
        className={`editor-drawer editor-${editor.state}`}
        title={null}
        closable={false}
        onClose={editor.close}
        destroyOnClose={false}
        visible={editor.drawerState.visible}
        keyboard={false}
      >
        <Provider store={editor.store}>
          <Editor />
          <MasterNode audioMaster={editor.audioMaster} />
          <OfflineAudioComponent />
        </Provider>
      </Drawer>
    </Container>
  );
};

export default EditorDrawer;
